import { MOD_LABEL } from "../lib/shortcuts";

// Libellés lisibles. « mod » devient ⌘ sur macOS, Ctrl ailleurs.
const LABELS = {
  shift: "Maj",
  alt: "Alt",
  esc: "Échap",
  escape: "Échap",
  enter: "Entrée",
  up: "↑",
  down: "↓",
  left: "←",
  right: "→",
  space: "Espace",
};

function label(key) {
  const k = String(key);
  if (k.toLowerCase() === "mod") return MOD_LABEL();
  return LABELS[k.toLowerCase()] || (k.length === 1 ? k.toUpperCase() : k);
}

// <Kbd combo="mod+k" /> ou <Kbd keys={["g", "u"]} sep="puis" />
export default function Kbd({ combo, keys, sep }) {
  const parts = keys || (combo ? String(combo).split("+") : []);
  return (
    <span className="adm-kbd">
      {parts.map((part, i) => (
        <span key={`${part}-${i}`} style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>
          {i > 0 && sep && <span>{sep}</span>}
          <kbd>{label(part)}</kbd>
        </span>
      ))}
    </span>
  );
}
